import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";

export default function CopyIndividualField({
  onClick,
  isPositionRelative,
  dataTestId,
}) {
  const [isCopied, setIsCopied] = useState(false);
  const handleClick = () => {
    onClick();
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 1500);
  };
  return (
    <button
      title="Copy text"
      className={`${
        isPositionRelative ? "" : "absolute z-10 top-0 right-0"
      } 
      ${
        isCopied
          ? "bg-green-500 border-green-500 hover:bg-green-700"
          : "bg-indigo-500 border-indigo-500 hover:bg-indigo-700"
      }
      self-center border rounded-full w-8 h-8 
       text-white transition-all font-medium outline-hidden text-sm shadow-md focus:outline-hidden`}
      onClick={handleClick}
      data-testid={dataTestId}
    >
      <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} />
    </button>
  );
}
